import React from 'react';
import axiosInstance from '../utils/axiosSetup.js';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';

const DeleteComponent = ({ url, id, fetchData }) => {
    const deleteItem = async () => {
        const isConfirm = await Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            return result.isConfirmed
        });

        if(!isConfirm){
            return;
        }

        axiosInstance.delete(`${process.env.REACT_APP_API_URL}/${url}/${id}`)
            .then(({data})=>{
                Swal.fire({
                    icon:"success",
                    text:data.message
                });
                fetchData();
            }).catch(({response:{data}})=>{
                Swal.fire({
                    text:data.message,
                    icon:"error"
                });
            });
    };

    return (
        <Link className="dropdown-item" to="#" 
            onClick={() => deleteItem()} >
            <i className="fa-regular fa-trash-can m-r-5"></i> Delete</Link>
    );
};

export default DeleteComponent;
